import type { FileUrlInfo } from '../../../utils/fileSharingUrlUtils';

import i18next from 'i18next';
import { useCallback } from 'react';

import { appStore } from '../../../stores/AppStore';
import { dialogManager } from '../../../stores/DialogManager';
import { formatDate } from '../../../utils/dialogUtils';

import { DialogType } from '@egr/xbox/egr-gui-dialogs/Constants';

export const useEmbed = (urlInfo?: FileUrlInfo) => {
    return useCallback(() => {
        if (!urlInfo) {
            return;
        }

        const shareableUrl = appStore.getShareLink(urlInfo, true);
        const expiryDate = urlInfo?.validUntil ? formatDate(urlInfo.validUntil, i18next.language) : '';

        dialogManager.showEmbedDialog({
            title: i18next.t('Embed'),
            url: shareableUrl,
            expiryDate: expiryDate,
            onClose: () => dialogManager.closeDialog(DialogType.EMBED),
        });
    }, [urlInfo]);
};
